import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse } from '@/shared/types';
import { createApi } from '@reduxjs/toolkit/query/react';

export interface fxScreenshotPaylod {
  fromCurrency: string;
  toCurrency: string;
  assessmentFolderId: string;
}
export const calcApi = createApi({
  reducerPath: 'calcApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getCalcDataBySheetId: builder.query<
      ApiResponse<{
        exchangeData: any;
        grossIncome: any;
        fundsAvailable: any;
        expenses: any;
        creditCard: any;
      }>,
      string
    >({
      query: (sheetId) => {
        const searchParams = new URLSearchParams({
          sheetId: sheetId,
        });
        return {
          url: `/v1/calc/sheet-data/cells?${searchParams.toString()}`,
        };
      },
    }),
    saveFxScreenshot: builder.mutation<ApiResponse<any>, fxScreenshotPaylod>({
      query: (body) => ({
        url: 'v1/calc/screenshot',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetCalcDataBySheetIdQuery, useSaveFxScreenshotMutation } =
  calcApi;
